import { CIInfoIcon, CILabel } from 'ccs-ui-components';
import { isArray } from 'lodash';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
  IQueryPathParam,
  IServiceOperationValidationModel
} from '../../../../../../../models';
import ServiceOperationQueryItem from '../param-item/ServiceOpsQueryItem';
import classes from './QueryItemWrapper.module.scss';
import QueryParamField from './QueryParamField';

interface IQueryItemWrapperProps {
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  serviceOpsFormData: IServiceOperationValidationModel;
  onAddQueryHandler: () => void;
  queryParamList: IQueryPathParam[];
  isEditOrCreate: boolean;
  onQueryItemChange: (obj: IQueryPathParam) => void;
  onQueryItemDelete: (index: number) => void;
}
const QueryItemWrapper = ({
  handleInputChange,
  serviceOpsFormData,
  onAddQueryHandler,
  queryParamList,
  isEditOrCreate,
  onQueryItemChange,
  onQueryItemDelete
}: IQueryItemWrapperProps) => {
  const { t: translate } = useTranslation();

  return (
    <Form.Group className="py-3">
      <CILabel id="queryParamKey" labelText={translate('service_operation_form.service_query_path_param')} infoIconText={translate('service_operation_form.query_path_param_info_bubble')} />
      <Row className={classes['param-container']}>
        <Row className={classes['param-header']}>
          <Col sm={5}>
            {translate('service_operation_form.param_key')}
            <CIInfoIcon iconTxt={String(translate('service_operation_form.query_path_param_key_info_bubble'))} />
          </Col>
          <Col sm={5} className={classes['value-header']}>
            {translate('service_operation_form.param_value')}
            <CIInfoIcon iconTxt={String(translate('service_operation_form.query_path_param_value_info_bubble'))} />
          </Col>
        </Row>
        {isEditOrCreate && (
          <QueryParamField
            handleInputChange={handleInputChange}
            onAddQueryHandler={onAddQueryHandler}
            serviceOpsFormData={serviceOpsFormData}
          />
        )}
        {!isEditOrCreate
          && (!queryParamList
            || queryParamList?.length < 1
            || queryParamList === null) && (
            <Row className={classes['no-records']}>
              {translate('service_operation_form.no_records_query')}
            </Row>
          )}
        {queryParamList
          && isArray(queryParamList)
          && queryParamList.map((queryItem, index) => (
            <ServiceOperationQueryItem
              index={index}
              key={queryItem.key}
              queryParamKey={queryItem.key}
              value={queryItem.value}
              isEdit={queryItem.isEdit}
              isView={!isEditOrCreate}
              updateQuery={onQueryItemChange}
              deleteQuery={onQueryItemDelete}
              queryList={queryParamList}
            />
          ))}
      </Row>
    </Form.Group>
  );
};

export default QueryItemWrapper;
